<script setup lang="ts">
import { json, jsonParseLinter } from '@codemirror/lang-json';
import CodeMirror from 'vue-codemirror6';
import type { RejectType } from 'vince-core/utils/async';
import type { Form } from 'vince-core/pages/form-builder/types';


const { t } = useI18n();
let editReject: RejectType;
const visible = ref(false);
const form = ref<string | undefined>();

const show = (f: Form) => {
    form.value = JSON.stringify(f, null, 2);
    return new Promise((_resolve, reject) => {
        editReject = reject;
        visible.value = true;
    });
};

const cancel = () => {
    visible.value = false;
    editReject();
};

defineExpose({ show });
</script>
<template>
    <VDialog
        v-model:visible="visible"
        :title="t('formBuilder.formCodeHeader')"
        class="w-1/3"
        @cancel-action="cancel"
    >
        <template v-if="form">
            <div class="json-container">
                <code-mirror
                    :model-value="form"
                    class="json-editor"
                    :lang="json()"
                    minimal
                    readonly
                    :linter="jsonParseLinter()"
                />
            </div>
        </template>
    </VDialog>
</template>

<style scoped src="vince-core/assets/styles/code-editor-font.css">
.json-container {
    height: 50%;
    min-height: 50%;
    max-height: 50%;
    overflow: auto;
}
.json-editor {
    height: 100%;
    min-height: 100%;
    max-height: 100%;
}
:deep(.cm-editor) {
    height: 100%;
    max-height: 100%;
}

:deep(.cm-scroller) {
    height: 100%;
    max-height: 100%;
}
</style>
